export const sharedEn = {
    seo: {
        homeTitle: 'Premium Webflow Template Designs',
        insightsTitle: 'Insights',
        insightsDescription: 'Webflow tips, guides and insights from the Wedoflow team. Learn how to build high-performing websites faster.',
        insightsSchemaName: 'Wedoflow Insights',
        insightsBreadcrumbHome: 'Home',
        insightsBreadcrumbInsights: 'Insights',
        templatesTitle: 'Premium Webflow Templates',
        templatesSchemaName: 'Premium Webflow Templates',
        templatesBreadcrumb: 'Templates',
        tagsTitle: 'Responsive Webflow Templates → Tags',
        tagsDescription: 'Browse our solution-driven Webflow templates designed for easy personalization and fast launching. Get your perfect Webflow template and start your journey.',
        tagsSchemaName: 'Webflow Template Tags',
        tagsBreadcrumbTags: 'Tags',
        tagTitle: '{name} Webflow Templates',
        categoryTitle: '{name} Webflow Templates',
        blogCategoryTitle: '{name} Insights',
        authorTitle: 'Insights from {name}',
        templateTitle: '{name} Webflow Template',
        contactTitle: 'Contact',
        contactSchemaDescription: 'Get in touch with the Wedoflow team about our premium Webflow templates, the all-access pass, or any question you have.',
        contactSchemaName: 'Contact Wedoflow',
        contactBreadcrumbHome: 'Home',
        contactBreadcrumbContact: 'Contact',
        siteDescription: 'Explore our 210+ premium and unique Webflow templates, from Portfolio, Agency, SaaS, Business, and other categories. High-performing & easy to customize.',
        homeSchemaName: 'Wedoflow — Premium Webflow Templates Marketplace'
    },
    ui: {
        navNewBadge: 'NEW',
        menuAriaLabel: 'Menu',
        languageAriaLabel: 'Change language',
        languageHeading: 'Language',
        testimonial1Quote: "I choose wedoflows’ template for my advertising portfolio because it was a very unique, functional design. I appreciate the clean code and the UX thought that went into the template. Very content with the purchase! Thank you!",
        testimonial1Role: 'Associate Creative Director',
        testimonial2Quote: 'I bought for my startup the Italic and Aura designs. Both are beautiful!',
        testimonial2Role: 'CEO',
        testimonial3Quote: 'Hands down the best dynamic template source. The wedoflow templates stood out from all other templates. Clear typography, great choices of colors and fonts. Easy to work templates. And above all their after sale support was also great.',
        testimonial3Role: 'Product Designer',
        testimonial4Quote: "Just wanted to say I love your work and I think you’ve done an amazing job with your templates.",
        testimonial5Quote: 'I recently bought a template from you and have been using it on Webflow. It is great, I love it!',
        testimonial6Quote: 'I really love the Ingenium Template.',
        testimonialWebsite: 'Website',
        shareOn: 'Share on {name}',
        sliderPreviewAlt: '{name} preview {n}',
        sliderPrev: 'Previous slide',
        sliderNext: 'Next slide',
        sliderShowSlide: 'Show slide {n}',
        tagsH1Line1: 'Webflow',
        tagsH1Line2: 'Template',
        tagsH1Accent: 'tags',
        // `{name}` is rendered as the accented word, so each language keeps its own word order.
        tagDetailH1: '{name} templates',
        categoryH1: '{name} website templates in Webflow'
    }
}

export const sharedDe: typeof sharedEn = {
    seo: {
        homeTitle: 'Premium Webflow-Vorlagen-Designs',
        insightsTitle: 'Einblicke',
        insightsDescription: 'Webflow-Tipps, Anleitungen und Einblicke vom Wedoflow-Team. Lerne, wie du leistungsstarke Websites schneller erstellst.',
        insightsSchemaName: 'Wedoflow Einblicke',
        insightsBreadcrumbHome: 'Startseite',
        insightsBreadcrumbInsights: 'Einblicke',
        templatesTitle: 'Premium Webflow-Vorlagen',
        templatesSchemaName: 'Premium Webflow-Vorlagen',
        templatesBreadcrumb: 'Vorlagen',
        tagsTitle: 'Responsive Webflow-Vorlagen → Tags',
        tagsDescription: 'Entdecke unsere lösungsorientierten Webflow-Vorlagen – einfach anzupassen und schnell zu veröffentlichen. Finde deine perfekte Webflow-Vorlage und starte durch.',
        tagsSchemaName: 'Webflow-Vorlagen-Tags',
        tagsBreadcrumbTags: 'Tags',
        tagTitle: '{name} Webflow-Vorlagen',
        categoryTitle: '{name} Webflow-Vorlagen',
        blogCategoryTitle: '{name} Einblicke',
        authorTitle: 'Einblicke von {name}',
        templateTitle: '{name} Webflow-Vorlage',
        contactTitle: 'Kontakt',
        contactSchemaDescription: "Nimm Kontakt mit dem Wedoflow-Team auf – bei Fragen zu unseren Premium-Webflow-Vorlagen, dem All-Access-Pass oder anderen Anliegen.",
        contactSchemaName: 'Wedoflow kontaktieren',
        contactBreadcrumbHome: 'Startseite',
        contactBreadcrumbContact: 'Kontakt',
        siteDescription: 'Entdecke unsere 210+ einzigartigen Premium-Webflow-Vorlagen aus den Bereichen Portfolio, Agentur, SaaS, Business und mehr. Leistungsstark und einfach anpassbar.',
        homeSchemaName: 'Wedoflow — Premium Webflow-Vorlagen-Marktplatz'
    },
    ui: {
        navNewBadge: 'NEU',
        menuAriaLabel: 'Menü',
        languageAriaLabel: 'Sprache wechseln',
        languageHeading: 'Sprache',
        testimonial1Quote: "Ich habe die Wedoflow-Vorlage für mein Werbungsportfolio gewählt, weil es ein sehr einzigartiges und funktionales Design war. Ich schätze den sauberen Code und den UX-Gedanken, der in die Vorlage eingeflossen ist. Sehr zufrieden mit dem Kauf! Danke!",
        testimonial1Role: 'Associate Creative Director',
        testimonial2Quote: "Ich habe für mein Startup die Italic- und Aura-Designs gekauft. Beide sind wunderschön!",
        testimonial2Role: 'CEO',
        testimonial3Quote: "Mit Abstand die beste Quelle für dynamische Vorlagen. Die Wedoflow-Vorlagen haben sich von allen anderen abgehoben. Klare Typografie, tolle Farb- und Schriftwahl. Einfach zu bearbeitende Vorlagen. Und der Kundendienst nach dem Kauf war ebenfalls hervorragend.",
        testimonial3Role: 'Produktdesigner',
        testimonial4Quote: "Ich wollte nur sagen, dass ich deine Arbeit liebe und du mit deinen Vorlagen einen fantastischen Job gemacht hast.",
        testimonial5Quote: "Ich habe neulich eine Vorlage von dir gekauft und sie in Webflow im Einsatz. Sie ist großartig, ich liebe sie!",
        testimonial6Quote: 'Ich liebe die Ingenium-Vorlage wirklich.',
        testimonialWebsite: 'Website',
        shareOn: 'Auf {name} teilen',
        sliderPreviewAlt: '{name} Vorschau {n}',
        sliderPrev: 'Vorherige Folie',
        sliderNext: 'Nächste Folie',
        sliderShowSlide: 'Folie {n} anzeigen',
        tagsH1Line1: 'Webflow',
        tagsH1Line2: 'Tags für',
        tagsH1Accent: 'Vorlagen',
        tagDetailH1: 'Vorlagen für {name}',
        categoryH1: '{name} Website-Vorlagen in Webflow'
    }
}

export const sharedFr: typeof sharedEn = {
    seo: {
        homeTitle: 'Designs de modèles Webflow premium',
        insightsTitle: 'Insights',
        insightsDescription: "Conseils Webflow, guides et insights de l’équipe Wedoflow. Apprenez à créer des sites performants plus rapidement.",
        insightsSchemaName: 'Wedoflow Insights',
        insightsBreadcrumbHome: 'Accueil',
        insightsBreadcrumbInsights: 'Insights',
        templatesTitle: "Modèles Webflow premium",
        templatesSchemaName: "Modèles Webflow premium",
        templatesBreadcrumb: 'Modèles',
        tagsTitle: "Modèles Webflow responsives → Tags",
        tagsDescription: "Parcourez nos modèles Webflow orientés solutions, faciles à personnaliser et rapides à publier. Trouvez votre modèle Webflow idéal et lancez-vous.",
        tagsSchemaName: "Tags de modèles Webflow",
        tagsBreadcrumbTags: 'Tags',
        tagTitle: 'Modèles Webflow {name}',
        categoryTitle: 'Modèles Webflow {name}',
        blogCategoryTitle: '{name} Insights',
        authorTitle: 'Insights de {name}',
        templateTitle: "Modèle Webflow {name}",
        contactTitle: 'Contact',
        contactSchemaDescription: "Contactez l’équipe Wedoflow pour toute question sur nos modèles Webflow premium, le pass All-Access ou autre sujet.",
        contactSchemaName: 'Contacter Wedoflow',
        contactBreadcrumbHome: 'Accueil',
        contactBreadcrumbContact: 'Contact',
        siteDescription: "Découvrez nos 210+ modèles Webflow premium et uniques dans les catégories Portfolio, Agence, SaaS, Business et plus encore. Performants et faciles à personnaliser.",
        homeSchemaName: "Wedoflow — Marché de modèles Webflow premium"
    },
    ui: {
        navNewBadge: 'NOUVEAU',
        menuAriaLabel: 'Menu',
        languageAriaLabel: 'Changer de langue',
        languageHeading: 'Langue',
        testimonial1Quote: "J’ai choisi le modèle Wedoflow pour mon portfolio publicitaire car il proposait un design très unique et fonctionnel. J’apprécie la propreté du code et la réflexion UX intégrée au modèle. Très satisfait de l’achat ! Merci !",
        testimonial1Role: 'Directeur créatif adjoint',
        testimonial2Quote: "J’ai acheté pour ma start-up les designs Italic et Aura. Les deux sont magnifiques !",
        testimonial2Role: 'PDG',
        testimonial3Quote: "La meilleure source de modèles dynamiques, sans hésitation. Les modèles Wedoflow se distinguent de tous les autres. Typographie claire, excellents choix de couleurs et de polices. Des modèles faciles à travailler. Et le support après-vente était excellent.",
        testimonial3Role: 'Designer produit',
        testimonial4Quote: "Je voulais juste dire que j’adore votre travail et que vous avez fait un travail remarquable avec vos modèles.",
        testimonial5Quote: "J’ai récemment acheté un modèle chez vous et je l’utilise sur Webflow. Il est excellent, je l’adore !",
        testimonial6Quote: "J’aime vraiment le modèle Ingenium.",
        testimonialWebsite: 'Site web',
        shareOn: 'Partager sur {name}',
        sliderPreviewAlt: "Aperçu {n} de {name}",
        sliderPrev: 'Diapositive précédente',
        sliderNext: 'Diapositive suivante',
        sliderShowSlide: 'Afficher la diapositive {n}',
        tagsH1Line1: 'Webflow',
        tagsH1Line2: 'Tags de',
        tagsH1Accent: 'modèles',
        tagDetailH1: 'Modèles {name}',
        categoryH1: "Modèles de sites {name} dans Webflow"
    }
}
